var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "pull-right-container" }, [
    _vm.unreadHelpMessagesCount > 0
      ? _c("small", { staticClass: "label pull-right bg-red" }, [
          _vm._v(_vm._s(_vm.unreadHelpMessagesCount)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.unreadDirectMessagesCount > 0
      ? _c("small", { staticClass: "label pull-right bg-light-blue" }, [
          _vm._v(_vm._s(_vm.unreadDirectMessagesCount)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }